import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-685711c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popUp" }
const _hoisted_2 = {
  class: "wrapper",
  ref: "modal"
}
const _hoisted_3 = { class: "wrapper-title" }
const _hoisted_4 = { class: "wrapper-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$localize('warning.text')), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$localize('beta.user.add.contact')), 1)
      ])
    ], 512)
  ]))
}